// btw-front/src/api/partnerReps.js
// 파트너 영업대표 / 기술지원 CRUD — /partners/edit 페이지 + 딜 등록 셀렉트 소스.
import { api } from "./client";

async function list(path) {
  const res = await api.get(path);
  return res && res.items ? res.items : [];
}

export const listSalesReps = () => list("/partner/sales-reps");
export const createSalesRep = (payload) => api.post("/partner/sales-reps", payload);
export const updateSalesRep = (id, payload) =>
  api.put(`/partner/sales-reps/${encodeURIComponent(id)}`, payload);
export const deleteSalesRep = (id) => api.del(`/partner/sales-reps/${encodeURIComponent(id)}`);

export const listTechSupports = () => list("/partner/tech-supports");
export const createTechSupport = (payload) => api.post("/partner/tech-supports", payload);
export const updateTechSupport = (id, payload) =>
  api.put(`/partner/tech-supports/${encodeURIComponent(id)}`, payload);
export const deleteTechSupport = (id) =>
  api.del(`/partner/tech-supports/${encodeURIComponent(id)}`);
